module.exports = __webpack_public_path__ + "img/demoAppDashboard.f65cd278.png";